import { render } from "./DashboardPrincipal.vue?vue&type=template&id=2f689180&scoped=true"
import script from "./DashboardPrincipal.vue?vue&type=script&lang=js"
export * from "./DashboardPrincipal.vue?vue&type=script&lang=js"

import "./DashboardPrincipal.vue?vue&type=style&index=0&id=2f689180&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f689180"]])

export default __exports__